declare var argon2: any;

export async function verifyArgon2(password: string, hash: string): Promise<boolean> {
  if (!(window as any).argon2) {
    await loadArgon2Script();
  }
  try {
    await (window as any).argon2.verify({ pass: password, encoded: hash });
    return true;
  } catch (e: any) {
    if (e && e.message && e.message.includes('does not match')) {
      // Mot de passe incorrect (normal)
      return false;
    }
    console.error('Erreur Argon2:', e);
    return false;
  }
}

function loadArgon2Script(): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'assets/argon2/argon2-bundled.min.js'; // version bundled
    script.onload = () => resolve();
    script.onerror = () => reject('Impossible de charger argon2-bundled.min.js');
    document.body.appendChild(script);
  });
}
